import * as React from 'react'
import TableCheckboxHeader from './TableCheckboxHeader'
import TableTextHeader from './TableTextHeader'
import { SortDirection, TableHeaderColumn } from '@/modules/drivers/types/table'

export const TableHeader = ({
  toggleAll = () => {},
  isSelectedAny = false,
  columns,
  rounded = false,
  bolder = false,
  opacity = false,
  disabledToggle = false,
  fontSize = 'sm',
  onHeaderClick,
  sticky = false,
  sortConfig,
  maxWidthOff = false,
  compact = false,
  transparent = false,
  disabledCheckboxToggle = false,
}: {
  disabledToggle?: boolean
  toggleAll?: (checked: boolean, isActive: boolean) => void
  isSelectedAny?: boolean
  columns: TableHeaderColumn[]
  rounded?: boolean
  bolder?: boolean
  opacity?: boolean
  fontSize?: 'sm' | 'md'
  sticky?: boolean
  onHeaderClick?: (key: string) => void
  sortConfig: { key: string; direction: SortDirection } | null
  maxWidthOff?: boolean
  compact?: boolean
  transparent?: boolean
  disabledCheckboxToggle?: boolean
}) => {
  return (
    <thead
      className={`notches-border--right tw-w-full tw-select-none tw-border-b ${transparent ? 'tw-bg-transparent' : 'tw-bg-content-primary'} ${sticky ? 'tw-sticky tw-top-0 tw-z-50' : ''} ${rounded ? 'tw-rounded-xl' : ''} `}
    >
      <tr>
        {/* {!disabledToggle && ( */}
        {!disabledCheckboxToggle && (
          <TableCheckboxHeader
            disabled={disabledToggle}
            toggleAll={toggleAll}
            isSelectedAny={isSelectedAny}
            transparent={transparent}
          />
        )}
        {/* // )} */}
        {columns.map((col) => (
          <TableTextHeader
            maxWidthOff={maxWidthOff}
            key={col.title}
            fontSize={fontSize}
            bolder={bolder}
            opacity={opacity}
            tooltip={col?.tooltip}
            sort={col.sort}
            compact={compact}
            onClick={() => {
              if (col.sort && !isSelectedAny) onHeaderClick?.(col.key)
            }}
            sortDirection={
              sortConfig?.key === col.key && col.sort
                ? sortConfig.direction
                : null
            }
          >
            {col.headerContent ?? col.title}
          </TableTextHeader>
        ))}
      </tr>
    </thead>
  )
}
